import PointOfSale from "./sales/PointOfSale";
import EndOfDay from "./sales/EndOfDay";
import WholesalePos from "./sales/WholesalePos";
import WarehousePos from "./sales/WarehousePos";
import TrialBalance from "./finance/TrialBalance";
import UpdateBarcode from "./inventory/UpdateBarcode";
import WholesalePrices from "./inventory/WholesalePrices";
import UserManagement from "./admin/UserManagement";
import AccountStatement from "./finance/AccountStatement";
import TransactionEntries from "./finance/TransactionEntries";
import AccountForm from "./finance/AccountForm";
import Availability from "./inventory/Availability";
import AdjustStock from "./inventory/AdjustStock";
import AddProduct from "./inventory/AddProduct";
import Assets from "./assets/Assets";
import AssetRegister from "./assets/AssetRegister";
import ActiveSessions from "./admin/ActiveSessions";
import ApprovedPOs from "./customers/ApprovedPOs";
import VerifyPayment from "./finance/VerifyPayment";
import ReconReport from "./inventory/ReconReport";
import Replenishments from "./inventory/Replenishments";
import Replenish from "./inventory/Replenish";
import StockRecon from "./inventory/StockRecon";
import StockList from "./inventory/StockList";
import CreatePO from "./purchasing/CreatePO";
import Hub from "./Hub";
import ServiceCatalog from "./services/ServiceCatalog";
import ServicePaymentsReport from "./services/ServicePaymentsReport";
import StockExpiry from "./inventory/StockExpiry";
import StockAvailability from "./inventory/StockAvailability";
import InventoryOverview from "./inventory/InventoryOverview";
import SalesAnalytics from "./sales/SalesAnalytics";
import SalesDay from "./sales/SalesDay";
import SalesMonthly from "./sales/SalesMonthly";
import ProductSales from "./sales/ProductSales";
import PeriodicSales from "./sales/PeriodicSales";
import CompareProducts from "./sales/CompareProducts";
import DailyDashboard from "./sales/DailyDashboard";
import ZeroStock from "./inventory/ZeroStock";
import RefillReport from "./inventory/RefillReport";
import Purchasing from "./purchasing/Purchasing";
import ReceivePayment from "./finance/ReceivePayment";
import CashReceipts from "./finance/CashReceipts";
import AccountBalances from "./finance/AccountBalances";
import JournalEntry from "./finance/JournalEntry";
import Payables from "./finance/Payables";
import Employees from "./hr/Employees";
import PayrollCenter from "./hr/PayrollCenter";
import MyHR from "./hr/MyHR";
import LeaveRequests from "./hr/LeaveRequests";
import Logs from "./admin/Logs";
import Profile from "./admin/Profile";
import GrnList from "./customers/GrnList";
import ClientSms from "./customers/ClientSms";
import PurchaseHistory from "./purchasing/PurchaseHistory";
import EodHistory from "./sales/EodHistory";
import EodDetails from "./sales/EodDetails";
import ExpiryDashboard from "./inventory/ExpiryDashboard";
import Advances from "./finance/Advances";
import PosPayments from "./sales/PosPayments";
import PoList from "./purchasing/PoList";
import GrnReceive from "./grn/GrnReceive";
import GrnRegister from "./grn/GrnRegister";
import BalanceSheet from "./finance/BalanceSheet";
import IncomeStatement from "./finance/IncomeStatement";
import CashFlow from "./finance/CashFlow";
import Clients from "./customers/Clients";
import DocPrint from "./customers/DocPrint";
import ProductEdit from "./inventory/ProductEdit";
import StockPosition from "./inventory/StockPosition";
import CountSheet from "./inventory/CountSheet";
import MobileMoney from "./mobile/MobileMoney";
import MmFloat from "./mobile/MmFloat";
import MmHistory from "./mobile/MmHistory";
import MmReport from "./mobile/MmReport";
import Receivables from "./finance/Receivables";
import PaymentsAnalytics from "./finance/PaymentsAnalytics";
import OtherPayments from "./finance/OtherPayments";
import PaymentsAll from "./finance/PaymentsAll";
import InvoiceApproval from "./invoices/InvoiceApproval";
import InvoiceView from "./invoices/InvoiceView";
import CreditSale from "./invoices/CreditSale";
import ProductSalesReport from "./sales/ProductSalesReport";
import ProductList from "./inventory/ProductList";
import EmployeeRegister from "./hr/EmployeeRegister";
import EmployeeOther from "./hr/EmployeeOther";
import LeaveRequestForm from "./hr/LeaveRequestForm";
import GrnPay from "./grn/GrnPay";
import UpdateAsset from "./assets/UpdateAsset";

const ProductListAlias = () => <StockList slug="AddPayment" />;
// assetTransaction.php and stockMgt.php are menus of links
const AssetHub = () => <Hub slug="assetTransaction" links={[
  ["PaymentList", "fa-money-bill-wave", "Record cash transaction"],
  ["managingcustomercredit", "fa-user-check", "Customer credit processing"],
  ["stockMgt", "fa-boxes-stacked", "Stock and inventory management"],
  ["assets", "fa-building", "Fixed assets management"],
  ["invoice_payments", "fa-hand-holding-dollar", "Receivable aging"],
]} />;
const RevenueHub = () => <Hub slug="revenuetransaction" links={[
  ["sales_record", "fa-cart-plus", "Record product sale"],
  ["service_income", "fa-briefcase", "Process service earnings"],
  ["discounts_refunds", "fa-rotate-left", "Apply discounts and refunds"],
  ["contractual_billing", "fa-file-signature", "Contract-based revenue"],
]} />;
const AnalyticsHub = () => <Hub slug="reportAnalytics" links={[
  ["saledates", "fa-calendar-days", "Periodic sales analytics"],
  ["productdates", "fa-boxes-stacked", "Product sales analytics"],
  ["stockAnalysis", "fa-warehouse", "Product availability"],
  ["sales_analysis", "fa-chart-line", "Daily sales dashboard"],
  ["sales-report", "fa-code-compare", "Compare two products"],
]} />;
const EquityHub = () => <Hub slug="equitytransaction" links={[
  ["assets", "fa-building", "Record fixed assets"],
  ["capitalFund", "fa-piggy-bank", "Capital transactions"],
]} />;
const ExpenseHub = () => <Hub slug="expensetransaction" links={[
  ["salaries_disbursement", "fa-money-check-dollar", "Process payroll"],
  ["depreciation_entry", "fa-arrow-trend-down", "Record depreciation expense"],
]} />;
const ReportsHub = () => <Hub slug="financialReports" links={[
  ["trial_balance", "fa-scale-balanced", "Trial balance"],
  ["accountBalance", "fa-book", "Account balances"],
  ["callFinance", "fa-file-invoice-dollar", "Income statement"],
  ["callBalancesheet", "fa-scale-unbalanced", "Balance sheet"],
]} />;
const HrHub = () => <Hub slug="HrMng" links={[
  ["addEmployee", "fa-id-card", "Employee personal details"],
  ["otherStaffInfo", "fa-circle-info", "Employee other details"],
  ["PayrolManagement", "fa-file-invoice-dollar", "Generate payroll"],
  ["payroll", "fa-circle-check", "Verification & payroll approval"],
  ["payroll-run-view", "fa-person-running", "Payroll run"],
  ["leaveList", "fa-calendar-days", "Leave management"],
]} />;
const InvoicePrint = () => <DocPrint kind="invoice" />;
const PoPrint = () => <DocPrint kind="po" />;
const CreditHub = () => <Hub slug="managingcustomercredit" links={[
  ["invoice", "fa-file-invoice", "Generate invoice"],
  ["invoice_approval", "fa-circle-check", "Authorize invoice"],
]} />;
const LiabilityHub = () => <Hub slug="liabilityTransaction" links={[
  ["Approvedpo_list", "fa-clipboard-check", "Purchase orders"],
  ["po_list", "fa-user-check", "Approve purchase orders"],
  ["grn", "fa-truck-ramp-box", "Generate GRN"],
  ["other_payments_form", "fa-credit-card", "Process vendor payment"],
  ["payableList", "fa-money-bill-wave", "Payable aging"],
]} />;
// payroll: one page; the old addresses open it at the matching step
const PayrollGenerate = () => <PayrollCenter step="generate" />;
const PayrollPost = () => <PayrollCenter step="post" />;
const StockHub = () => <Hub slug="stockMgt" links={[
  ["productlist", "fa-square-plus", "Inventories"],
  ["stockexpiry", "fa-hourglass-end", "Stock expiring in 30 days"],
]} />;

/*
 * Pages with their own custom screen. Any slug not listed here is drawn by GenericPage
 * from pageConfig.js. To replace a generic page, build a component and add it here.
 * Custom pages receive the signed-in user as the `user` prop.
 */
export const CUSTOM_PAGES = {
  pos: PointOfSale,
  end_of_day: EndOfDay,
  wholesale_pos: WholesalePos,
  warehousePos: WarehousePos,
  trial_balance: TrialBalance,
  update_barcode: UpdateBarcode,
  wholesale_prices: WholesalePrices,
  "user-management": UserManagement,
  accountStatement: AccountStatement,
  accountBalanceL: TransactionEntries,
  account_form: AccountForm,
  availabilty: Availability,
  adjust_stock: AdjustStock,
  productAdd: AddProduct,
  assets: Assets,
  asset_register: AssetRegister,
  assetTransaction: AssetHub,
  active_sessions: ActiveSessions,
  Approvedpo_list: ApprovedPOs,
  "verify-payment": VerifyPayment,
  stockrecon_report: ReconReport,
  addStockreplenish: Replenishments,
  stockReprenish: Replenish,
  stockrecon: StockRecon,
  addStock: StockList,
  AddPayment: ProductListAlias,
  purchase_order: CreatePO,
  stockMgt: StockHub,
  ServiceList: ServiceCatalog,
  service_payments_report: ServicePaymentsReport,
  stockexpiry: StockExpiry,
  stockanalytics: StockAvailability,
  stockAnalysis: InventoryOverview,
  select_statement: AccountStatement,
  sales: SalesAnalytics,
  sales_day: SalesDay,
  salesExtend: SalesMonthly,
  saleIndividual: ProductSales,
  saledates: PeriodicSales,
  "sales-report": CompareProducts,
  sales_analysis: DailyDashboard,
  report_zero_stock: ZeroStock,
  refill: RefillReport,
  purchasing: Purchasing,
  receive_payment: ReceivePayment,
  ReceiveCash: CashReceipts,
  "run-payroll": PayrollPost,
  "payroll-run-view": PayrollPost,
  accountBalance: AccountBalances,
  journal_entry: JournalEntry,
  payableList: Payables,
  addEmployee: Employees,
  payroll: PayrollCenter,
  PayrolManagement: PayrollGenerate,
  my_hr: MyHR,
  leaveList: LeaveRequests,
  logs: Logs,
  profile: Profile,
  callGrn: GrnList,
  "grn-report": GrnList,
  clientSms: ClientSms,
  purchase_history: PurchaseHistory,
  end_of_day_history: EodHistory,
  end_of_day_details: EodDetails,
  expiry_dashboard: ExpiryDashboard,
  ext_fund: Advances,
  GRNreceipts: PosPayments,
  po_list: PoList,
  grn: GrnReceive,
  grn_list: GrnRegister,
  GRNcall: GrnList,
  equitytransaction: EquityHub,
  expensetransaction: ExpenseHub,
  financialReports: ReportsHub,
  callBalancesheet: BalanceSheet,
  balanceSheet: BalanceSheet,
  income_statement: IncomeStatement,
  callFinance: IncomeStatement,
  cashflow: CashFlow,
  client: Clients,
  invoiceCall: InvoicePrint,
  poCall: PoPrint,
  productedit: ProductEdit,
  stockStatus: StockPosition,
  productprint: CountSheet,
  HrMng: HrHub,
  mobile_money: MobileMoney,
  mobile_money_float: MmFloat,
  mobile_money_history: MmHistory,
  mobile_money_report: MmReport,
  invoice_payments: Receivables,
  PaymentList: PaymentsAnalytics,
  other_payments_form: OtherPayments,
  paymentAjax: PaymentsAll,
  managingcustomercredit: CreditHub,
  invoice_approval: InvoiceApproval,
  invoice_view: InvoiceView,
  invoice: CreditSale,
  productdates: ProductSalesReport,
  productlist: ProductList,
  liabilityTransaction: LiabilityHub,
  employerAdd: EmployeeRegister,
  otherStaffInfo: EmployeeOther,
  LeaveRequest: LeaveRequestForm,
  make_grn_payment: GrnPay,
  update_asset: UpdateAsset,
  revenuetransaction: RevenueHub,
  reportAnalytics: AnalyticsHub,
};
